import React, { useContext, useState } from 'react'
import API from '../../../services/API'
// MUI Imports
import Autocomplete from '@mui/material/Autocomplete'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import { GlobalContext } from '../../../App'
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
} from '@mui/material'

const initNewPolicy = { policyTitle: '', category: '' }

const PolicyDescriptionPopup = ({ policies, getPolicies, open, onClose }) => {
  const [newPolicy, setNewPolicy] = useState(initNewPolicy)
  const { setToast } = useContext(GlobalContext)

  const handleClose = () => {
    setNewPolicy(initNewPolicy)
    onClose()
  }

  const handleSubmit = () => {
    API.post('/policies/descriptions', newPolicy)
      .then((res) => {
        if (res.status === 200) {
          getPolicies()
          setToast({ message: 'Policy Template Created' })
          handleClose()
        } else {
          setToast({ message: 'Could not save the policy template' })
        }
      })
      .catch((e) => console.log(e))
  }

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="xs">
      <DialogTitle>Add new policy template</DialogTitle>
      <DialogContent>
        <Stack gap={1} paddingTop={1}>
          <TextField
            label="Policy Title"
            value={newPolicy.policyTitle}
            autoComplete="off"
            onChange={(e) =>
              setNewPolicy((prev) => ({
                ...prev,
                policyTitle: e.target.value,
              }))
            }
            fullWidth
          />
          <Autocomplete
            fullWidth
            value={newPolicy.category}
            freeSolo
            autoSelect
            disableClearable
            onChange={(e, newValue) =>
              setNewPolicy((prev) => ({ ...prev, category: newValue }))
            }
            options={policies.reduce(
              (accumulator, policy) => {
                if (!accumulator.includes(policy.category)) {
                  accumulator.push(policy.category)
                }
                return accumulator
              },
              ['Clinical', 'Operational'],
            )}
            renderInput={(params) => <TextField label="Category" {...params} />}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button color="error" onClick={handleClose}>
          Cancel
        </Button>
        <Button
          color="success"
          disabled={!newPolicy.policyTitle.trim()}
          onClick={handleSubmit}
        >
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default PolicyDescriptionPopup
